// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-fab {
  position: fixed;
  bottom: 80px;
  left: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #0a2240;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  z-index: 99999;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.chat-fab:active {
  transform: scale(0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.chat-panel {
  position: fixed;
  bottom: 80px;
  left: 20px;
  width: 340px;
  height: 500px;
  background: white;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.2s ease;
}
@media (max-width: 420px) {
  .chat-panel {
    width: calc(100vw - 24px);
    right: 12px;
    bottom: 12px;
    height: 70vh;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.chat-header {
  background-color: #0a2240;
  color: white;
  padding: 10px 6px 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.chat-header .chat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 15px;
}
.chat-header .chat-title ion-icon {
  font-size: 18px;
}
.chat-header ion-button {
  --color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f3f5f8;
}

.chat-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #b0b8c4;
  gap: 10px;
  margin: auto;
}
.chat-empty ion-icon {
  font-size: 52px;
}
.chat-empty p {
  margin: 0;
  font-size: 14px;
}

.message-bubble {
  max-width: 82%;
  padding: 9px 13px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.45;
  word-break: break-word;
}
.message-bubble p {
  margin: 0;
  white-space: pre-wrap;
}
.message-bubble.user-bubble {
  align-self: flex-end;
  background: #0a2240;
  color: white;
  border-bottom-right-radius: 4px;
}
.message-bubble.bot-bubble {
  align-self: flex-start;
  background: white;
  color: #1a1a1a;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.09);
}
.message-bubble.loading {
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 14px 16px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #aab4c0;
  animation: dotBounce 1.2s ease-in-out infinite;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-7px);
  }
}
.chat-input-area {
  display: flex;
  align-items: flex-end;
  padding: 8px;
  border-top: 1px solid #e8ebef;
  background: white;
  gap: 4px;
  flex-shrink: 0;
}
.chat-input-area ion-textarea {
  flex: 1;
  --padding-start: 12px;
  --padding-end: 4px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --background: #f0f2f5;
  --border-radius: 20px;
  --color: #1a1a1a;
  font-size: 14px;
  max-height: 110px;
}
.chat-input-area ion-button {
  --padding-start: 6px;
  --padding-end: 6px;
  margin: 0;
  font-size: 22px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/chat.component.scss","webpack://./../../../../../../Luar%20Faria/source/repos/luarfaria/Legislapp/Legislapp.Mobile/src/app/chat/chat.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,0CAAA;EACA,uDAAA;ACCF;ADCE;EACE,qBAAA;EACA,wCAAA;ACCJ;;ADGA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;ACAF;ADEE;EAfF;IAgBI,yBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;ECCF;AACF;;ADEA;EACE;IACE,UAAA;IACA,uCAAA;ECCF;EDCA;IACE,UAAA;IACA,iCAAA;ECCF;AACF;ADEA;EACE,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;ACAF;ADEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;ACAJ;ADEI;EACE,eAAA;ACAN;ADIE;EACE,kCAAA;EACA,SAAA;ACFJ;;ADMA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;ACHF;;ADMA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;ACHF;ADKE;EACE,eAAA;ACHJ;ADME;EACE,SAAA;EACA,eAAA;ACJJ;;ADQA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;ACLF;ADOE;EACE,SAAA;EACA,qBAAA;ACLJ;ADQE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;ACNJ;ADSE;EACE,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,yCAAA;ACPJ;ADUE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;ACRJ;;ADYA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;ACTF;ADWE;EACE,qBAAA;ACTJ;ADYE;EACE,qBAAA;ACVJ;;ADcA;EACE;IAGE,wBAAA;ECbF;EDeA;IACE,2BAAA;ECbF;AACF;ADgBA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,QAAA;EACA,cAAA;ACdF;ADgBE;EACE,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ACdJ;ADiBE;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;ACfJ","sourcesContent":[".chat-fab {\r\n  position: fixed;\r\n  bottom: 80px;\r\n  left: 20px;\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 50%;\r\n  background-color: #0a2240;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 26px;\r\n  z-index: 99999;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n\r\n  &:active {\r\n    transform: scale(0.9);\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n  }\r\n}\r\n\r\n.chat-panel {\r\n  position: fixed;\r\n  bottom: 80px;\r\n  left: 20px;\r\n  width: 340px;\r\n  height: 500px;\r\n  background: white;\r\n  border-radius: 18px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);\r\n  z-index: 99999;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  animation: slideUp 0.2s ease;\r\n\r\n  @media (max-width: 420px) {\r\n    width: calc(100vw - 24px);\r\n    right: 12px;\r\n    bottom: 12px;\r\n    height: 70vh;\r\n  }\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px) scale(0.97);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.chat-header {\r\n  background-color: #0a2240;\r\n  color: white;\r\n  padding: 10px 6px 10px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-shrink: 0;\r\n\r\n  .chat-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n\r\n    ion-icon {\r\n      font-size: 18px;\r\n    }\r\n  }\r\n\r\n  ion-button {\r\n    --color: rgba(255, 255, 255, 0.85);\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.chat-messages {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  background: #f3f5f8;\r\n}\r\n\r\n.chat-empty {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #b0b8c4;\r\n  gap: 10px;\r\n  margin: auto;\r\n\r\n  ion-icon {\r\n    font-size: 52px;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.message-bubble {\r\n  max-width: 82%;\r\n  padding: 9px 13px;\r\n  border-radius: 18px;\r\n  font-size: 14px;\r\n  line-height: 1.45;\r\n  word-break: break-word;\r\n\r\n  p {\r\n    margin: 0;\r\n    white-space: pre-wrap;\r\n  }\r\n\r\n  &.user-bubble {\r\n    align-self: flex-end;\r\n    background: #0a2240;\r\n    color: white;\r\n    border-bottom-right-radius: 4px;\r\n  }\r\n\r\n  &.bot-bubble {\r\n    align-self: flex-start;\r\n    background: white;\r\n    color: #1a1a1a;\r\n    border-bottom-left-radius: 4px;\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.09);\r\n  }\r\n\r\n  &.loading {\r\n    display: flex;\r\n    gap: 5px;\r\n    align-items: center;\r\n    padding: 14px 16px;\r\n  }\r\n}\r\n\r\n.dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #aab4c0;\r\n  animation: dotBounce 1.2s ease-in-out infinite;\r\n\r\n  &:nth-child(2) {\r\n    animation-delay: 0.2s;\r\n  }\r\n\r\n  &:nth-child(3) {\r\n    animation-delay: 0.4s;\r\n  }\r\n}\r\n\r\n@keyframes dotBounce {\r\n  0%,\r\n  60%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  30% {\r\n    transform: translateY(-7px);\r\n  }\r\n}\r\n\r\n.chat-input-area {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  padding: 8px;\r\n  border-top: 1px solid #e8ebef;\r\n  background: white;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n\r\n  ion-textarea {\r\n    flex: 1;\r\n    --padding-start: 12px;\r\n    --padding-end: 4px;\r\n    --padding-top: 8px;\r\n    --padding-bottom: 8px;\r\n    --background: #f0f2f5;\r\n    --border-radius: 20px;\r\n    --color: #1a1a1a;\r\n    font-size: 14px;\r\n    max-height: 110px;\r\n  }\r\n\r\n  ion-button {\r\n    --padding-start: 6px;\r\n    --padding-end: 6px;\r\n    margin: 0;\r\n    font-size: 22px;\r\n    height: 40px;\r\n  }\r\n}\r\n",".chat-fab {\n  position: fixed;\n  bottom: 80px;\n  left: 20px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background-color: #0a2240;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 26px;\n  z-index: 99999;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.chat-fab:active {\n  transform: scale(0.9);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.chat-panel {\n  position: fixed;\n  bottom: 80px;\n  left: 20px;\n  width: 340px;\n  height: 500px;\n  background: white;\n  border-radius: 18px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);\n  z-index: 99999;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: slideUp 0.2s ease;\n}\n@media (max-width: 420px) {\n  .chat-panel {\n    width: calc(100vw - 24px);\n    right: 12px;\n    bottom: 12px;\n    height: 70vh;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n.chat-header {\n  background-color: #0a2240;\n  color: white;\n  padding: 10px 6px 10px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n.chat-header .chat-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 15px;\n}\n.chat-header .chat-title ion-icon {\n  font-size: 18px;\n}\n.chat-header ion-button {\n  --color: rgba(255, 255, 255, 0.85);\n  margin: 0;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #f3f5f8;\n}\n\n.chat-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #b0b8c4;\n  gap: 10px;\n  margin: auto;\n}\n.chat-empty ion-icon {\n  font-size: 52px;\n}\n.chat-empty p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.message-bubble {\n  max-width: 82%;\n  padding: 9px 13px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.45;\n  word-break: break-word;\n}\n.message-bubble p {\n  margin: 0;\n  white-space: pre-wrap;\n}\n.message-bubble.user-bubble {\n  align-self: flex-end;\n  background: #0a2240;\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n.message-bubble.bot-bubble {\n  align-self: flex-start;\n  background: white;\n  color: #1a1a1a;\n  border-bottom-left-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.09);\n}\n.message-bubble.loading {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  padding: 14px 16px;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #aab4c0;\n  animation: dotBounce 1.2s ease-in-out infinite;\n}\n.dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes dotBounce {\n  0%, 60%, 100% {\n    transform: translateY(0);\n  }\n  30% {\n    transform: translateY(-7px);\n  }\n}\n.chat-input-area {\n  display: flex;\n  align-items: flex-end;\n  padding: 8px;\n  border-top: 1px solid #e8ebef;\n  background: white;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.chat-input-area ion-textarea {\n  flex: 1;\n  --padding-start: 12px;\n  --padding-end: 4px;\n  --padding-top: 8px;\n  --padding-bottom: 8px;\n  --background: #f0f2f5;\n  --border-radius: 20px;\n  --color: #1a1a1a;\n  font-size: 14px;\n  max-height: 110px;\n}\n.chat-input-area ion-button {\n  --padding-start: 6px;\n  --padding-end: 6px;\n  margin: 0;\n  font-size: 22px;\n  height: 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
